import { render, staticRenderFns } from "./SithMesStoolPrApplicationShippingDetailList.vue?vue&type=template&id=01c17e83&"
import script from "./SithMesStoolPrApplicationShippingDetailList.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPrApplicationShippingDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports